import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { Box, Button, Typography } from '@mui/material';
import { AlertDialog, RadioGroup } from '@utriper/core-ui';

const UPDATE_OPTION = {
    THIS: '1',
    ALL: '2',
    FOLLOWING: '3',
};

const FutureEventsModal = ({ open, event = {}, isDelete = false, onSubmit = () => {}, onClose = () => {}, loading = false }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_calendar.future_events_modal.${key}`);

    const updateOptions = [
        {
            id: UPDATE_OPTION.THIS,
            label: translate('update_options.this_event'),
        },
        {
            id: UPDATE_OPTION.ALL,
            label: translate('update_options.all_events'),
        },
        {
            id: UPDATE_OPTION.FOLLOWING,
            label: translate('update_options.this_and_following'),
        },
    ];

    const handleSubmit = (values) => {
        let all = false;
        let thisAndFollowing = false;

        if (values?.updateOption === UPDATE_OPTION.ALL) {
            all = true;
        } else if (values?.updateOption === UPDATE_OPTION.FOLLOWING) {
            thisAndFollowing = true;
        }

        onSubmit({ ...values, all, thisAndFollowing });
    };

    return (
        <AlertDialog
            open={open}
            handleClose={onClose}
            hideTitle
            hideActions
            maxWidth="xs"
            fullWidth
            dialogContent={
                <Form
                    onSubmit={handleSubmit}
                    initialValues={{
                        ...event,
                        updateOption: UPDATE_OPTION.THIS,
                    }}
                    render={({ handleSubmit }) => (
                        <Box component="form" id="future-events-modal-form" sx={{ width: '100%', pt: 2 }}>
                            <Typography fontSize={18} fontWeight="bold" sx={{ color: '#131313', my: 1 }}>
                                {isDelete ? translate('delete') : translate('update')}
                            </Typography>

                            <Box my={1}>
                                <Field id="updateOption" name="updateOption" component={RadioGroup} options={updateOptions} />
                            </Box>

                            <Box
                                sx={{
                                    pt: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    gap: '8px',
                                }}
                            >
                                <Button
                                    onClick={onClose}
                                    disabled={loading}
                                    sx={{
                                        color: '#131313',
                                        borderRadius: '8px',
                                        border: 'solid 1px #13131340',
                                        textTransform: 'none',
                                    }}
                                >
                                    {translate('cancel')}
                                </Button>
                                <Button
                                    onClick={handleSubmit}
                                    type="submit"
                                    variant="contained"
                                    disabled={loading}
                                    sx={{
                                        color: '#fff',
                                        backgroundColor: isDelete ? '#C51313' : '#137DC5',
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                    }}
                                >
                                    {isDelete ? translate('delete') : translate('update')}
                                </Button>
                            </Box>
                        </Box>
                    )}
                />
            }
        />
    );
};

export default FutureEventsModal;
